export {default as dispatch} from "./dispatch";



//////////////////
// WEBPACK FOOTER
// ./~/d3-dispatch/src/index.js
// module id = 6xBz
// module chunks = 0